import { forwardRef, ForwardRefExoticComponent, RefAttributes } from 'react';
import { FieldProps } from 'formik';

import Input, { IInputProps } from './Input';
import FieldWrapper from '../FieldWrapper/FieldWrapper';

interface InputFieldProps extends Partial<IInputProps>, RefAttributes<HTMLInputElement> {
  label?: string,
}

const InputField: ForwardRefExoticComponent<FieldProps & InputFieldProps> = forwardRef(
  ({ field, meta, form, label, ...rest },
    ref
  ) => {
    const hasError = !!(meta.touched && meta.error);
    return (
      <FieldWrapper error={hasError && meta.error} label={label}>
        <Input ref={ref} {...rest} {...field} hasError={hasError} />
      </FieldWrapper>
    );
  }
);

export default InputField;
